import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { PersonalizationPanel } from "./PersonalizationPanel";
import { CustomCursor } from "./CustomCursor";
import { SmoothScroll } from "./SmoothScroll";
import { FloatingContactCTA } from "./FloatingContactCTA";
import { ChatWidget } from "./ChatWidget";

export const Layout = ({ children }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <SmoothScroll>
      <CustomCursor />
      <Header />
      <main className="min-h-screen" data-testid="page-main">{children}</main>
      <Footer />
      <PersonalizationPanel />
      <FloatingContactCTA />
      <ChatWidget />
    </SmoothScroll>
  );
};

export default Layout;
